import { Wallet } from "lucide-react"
import { Card, StatusBadge, Currency } from "../../ui"
import { formatDate } from "../../constants"
import { HScroll } from "procurement/design/components/HScroll"

// F6 — "My Orders" Payment stage. Read-only, no actions: lists every payment
// batch ("đợt") for each Purchase this order produced, via
// GET /order-requests/{id}/lifecycle. Renders nothing when the order hasn't
// reached a Purchase yet, rather than fabricating an empty Payment section.
const PaymentLifecycleCard = ({ purchases }) => {
  const rows = purchases || []
  if (rows.length === 0) return null

  return (
    <Card icon={<Wallet aria-hidden />} title="Payment" subtitle="Every batch created against this order's purchase(s).">
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {rows.map((p) => {
          const batches = p.batches || []
          return (
          <div key={p.purchaseId}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <div style={{ fontSize: 13.5, fontWeight: 700, color: "var(--pc-ink)" }}>{p.poCode}</div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 12.5, color: "var(--pc-muted)" }}>
                  Remaining <Currency value={p.remaining} />
                </span>
                <StatusBadge status={p.status} />
              </div>
            </div>

            {batches.length === 0 ? (
              <p className="pc-muted" style={{ margin: 0 }}>
                No payment requests created yet.
              </p>
            ) : (
              <HScroll className="pc-table-wrap">
                <table className="pc-table">
                  <thead>
                    <tr>
                      <th>Batch</th>
                      <th className="pc-th-right">Amount</th>
                      <th>Status</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batches.map((b) => (
                      <tr key={b.id}>
                        <td>{b.batchLabel}</td>
                        <td className="pc-td-right">
                          <Currency value={b.amount} />
                        </td>
                        <td>
                          <StatusBadge status={b.status} />
                        </td>
                        <td>{formatDate(b.paidAt || b.sentToAccountingAt || b.submittedAt || b.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </HScroll>
            )}
          </div>
          )
        })}
      </div>
    </Card>
  )
}

export default PaymentLifecycleCard
